module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c09"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("Monkey Business")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("D")]), _vm._v("arwin was right—we are descended from monkeys.… Well, at least men are. A study conducted by Duke University, in January 2005, showed that male monkeys would give up their juice rewards in order to look at pictures of female monkeys’ bottoms. Since monkeys don’t have money, choosing pictures over juice is akin to paying for the images, and they don’t have Internet access, either. The rhesus macaque monkeys also splurged on photos of higher-ranking primates but had to be bribed with juice to make them look at lower-ranking monkeys. It has been rumored that "), _c('em', [_vm._v("Hustler")]), _vm._v(" founder, Larry Flynt, is considering publishing "), _c('em', [_vm._v("Porn-orangutan")]), _vm._v(" with a “Pri-mate” centerfold of the month."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center02"
  }, [_c('em', [_vm._v("Sign in a Zurich hotel:")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("BECAUSE OF THE IMPROPRIETY OF ENTERTAINING GUESTS OF THE OPPOSITE SEX IN THE BEDROOM, IT IS SUGGESTED THAT THE LOBBY BE USED FOR THIS PURPOSE.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26155db8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c09_r1.vue
// module id = 99
// module chunks = 0